import CheckBoxInputSet from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInputSet'
import type { ComponentPropsWithoutRef } from 'react'

const CheckBoxFeatureInputSet = (props: ComponentPropsWithoutRef<'li'>) => <CheckBoxInputSet className="w-[33%]" {...props} />

export default CheckBoxFeatureInputSet
